<template>
    <div class="f-text">
        <van-checkbox v-model="isAgree" icon-size=".24rem" :checked-color="checkedColor"></van-checkbox>
        <span >点击开通即为同意</span>
        <span @click="goAgreement1">《会员服务协议》</span>
        <span @click="goAgreement2" v-if="currentProduct && currentProduct.isPureSign">《自动续费协议》</span>
    </div>
</template>

<script>
import { Checkbox } from 'vant';
import Vue from 'vue';

Vue.use(Checkbox);

export default {
    props: {
        source: {   // and；ios
            type: String
        },
        checkedColor: {
            type: String
        },
        currentProduct: {
            type: Object,
        }
    },
    data() {
        return {
            isAgree: false // 默认不勾选
        }
    },
    methods: {
         goAgreement1() {
            let url = window.location.href.split('?')[0];
            let path = this.source === 'ios' ? url.split("member_ai_study").join('member_service_agreement') : url.split("member_ai_study").join('member_service_agreement');
            url = encodeURIComponent(path + '?hideTitleBar=false');
            window.location.href = "hybird://method/openNewWindow?url=" + url + "&title=小盒家长会员服务协议";
        },
        goAgreement2() {
            let url = window.location.href.split('?')[0];
            let path = this.source === 'ios' ? url.split("member_ai_study").join('member_xufei') : url.split("member_ai_study").join('member_xufei');
        
            url = encodeURIComponent(path + '?hideTitleBar=false')
            window.location.href = "hybird://method/openNewWindow?url=" + url + "&title=自动续费协议";;
        }
    }
}
</script>

<style lang="scss" scoped>
    .agreement {
        background: #ffffff;
        // width: 4.02rem;
        // padding: .6rem 0.0rem .46rem 1.7rem;
        display: flex;
        justify-content: space-between;
        font-size: .22rem;
        color: #43a5f3;
        i {
            color: #dfe4ee;
        }
    }
    .f-text{
    font-size: .24rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8597A6;
    line-height: .34rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .van-checkbox {
        margin-right: .1rem;
    }
    span{
        color: #9D5E43;
    }
}
</style>